/**
 * Copia texto al portapapeles. Usa la Clipboard API si hay contexto seguro (HTTPS);
 * si no (ej. el sistema corriendo por HTTP), cae a un fallback con textarea + execCommand.
 * Devuelve true si copió.
 */
export async function copiarTexto(texto) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(texto)
      return true
    }
  } catch { /* sigue al fallback */ }

  try {
    const ta = document.createElement('textarea')
    ta.value = texto
    ta.style.position = 'fixed'
    ta.style.top = '-9999px'
    ta.setAttribute('readonly', '')
    document.body.appendChild(ta)
    ta.select()
    ta.setSelectionRange(0, ta.value.length)
    const ok = document.execCommand('copy')
    document.body.removeChild(ta)
    return ok
  } catch {
    return false
  }
}
